<!--  
<div style="position: absolute; display: block; background-color: rgba(255, 255, 255, 0.6); width: 100%; height: 560%; z-index: 100000" [hidden]="!loading">
   
  <div style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%);">
     
    <div id="lottie-animation" style="width: 100px; height: 100px;"></div>
  </div>
</div>
 
<script src="https://cdnjs.cloudflare.com/ajax/libs/lottie-web/5.9.4/lottie.min.js"></script>
 
<script>
document.addEventListener('DOMContentLoaded', function() {
    var animation = lottie.loadAnimation({
        container: document.getElementById('lottie-animation'), // the dom element that will contain the animation
        renderer: 'svg', // SVG rendering
        loop: true, // Loop the animation
        autoplay: true, // Automatically start the animation
        path: './assets/img/Loader.json' // the path to the animation json
    });
});
</script> -->



<div style="
    position: absolute;
    display: block;
    background-color: rgba(255, 255, 255, 0.6);
    width: 100%;
    height: 560%;
    z-index: 100000;
  " [hidden]="!loading">
  <div style="
      position: fixed;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    ">
    <div class="loader"></div>
  </div>
</div>